module.exports = __webpack_public_path__ + "img/cix.91af0f00.svg";